import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

import ViewAutomation from './viewautomation';
import DeleteAutomation from './deleteautomation';
import TableAddress from './tableaddress';
import moment from 'moment';

class ListAutomations extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  componentDidUpdate() {
  }

  render() {
    const { user, errors, success, automations } = this.props;
    const {
      toggleModal,
      modalComponent,
      handleDeleteAutomation,
      handleUpdateAutomation,
    } = this.props;

    let noFiatAutomations = automations;
    if (automations && automations.length) {
      noFiatAutomations = automations.filter((item) => {
        let depositAsset;
        if (item && item.meta && item.meta.depositAsset) {
          depositAsset = item.meta.depositAsset;
        }
        return (
          depositAsset !== 'FIAT'
        );
      });
    }

    const tableLoop = noFiatAutomations && noFiatAutomations.length && noFiatAutomations.map((item, index) => {
      let depositAsset = '--';
      if (item && item.meta && item.meta.depositAsset) {
        depositAsset = item.meta.depositAsset;
      }

      const buyLoop = item.meta && item.meta.assetsToBuy && item.meta.assetsToBuy.length && item.meta.assetsToBuy.map((buy, index) => {
        const key = `buy-${index}`;
        let isLast;

        if (index === (item.meta.assetsToBuy.length - 1)) {
          isLast = true;
        }

        return (
          <span key={key}>
            <span className="">({buy.percentage}%)</span>
            &nbsp;
            <b>{buy.asset}</b>
            {isLast ? (null) : (
              <>
                &nbsp;&amp;&nbsp;
              </>
            )}
          </span>
        );
      });

      const key = `auto-${index}`;

      return (
        <tr key={key}>
          <td>{item.priority || '--'}</td>
          <td style={{textTransform: 'none'}}>
            When I deposit <b>{depositAsset || '--'}</b>, I want to buy {buyLoop}
          </td>
          {/* <td>{moment(item.updatedAt).format('L LT') || '--'}</td> */}
          <td className="automation-lg">
            <TableAddress
              useAsset={depositAsset}
            />
          </td>
          <td className="automation-sm">
            <button
              className="vt-t-btn"
              type="button"
              onClick={() => toggleModal(
                <ViewAutomation
                  toggleModal={toggleModal}
                  modalComponent={modalComponent}
                  automationDetails={item}
                  handleUpdateAutomation={handleUpdateAutomation}
                  handleDeleteAutomation={handleDeleteAutomation}
                />
                , false
              )}
            >
              <FontAwesomeIcon
                icon={faEllipsisV}
              />
            </button>
          </td>
          <td className="automation-lg">
            <button
              className="vt-t-btn vt-t-del"
              type="button"
              onClick={() => toggleModal(
                <DeleteAutomation
                  toggleModal={toggleModal}
                  modalComponent={modalComponent}
                  automationDetails={item}
                  handleDeleteAutomation={handleDeleteAutomation}
                />
                , false
              )}
            >
              <FontAwesomeIcon
                icon={faTrashAlt}
              />
            </button>
          </td>
        </tr>
      );
    });

    return (
      <div className="cell panel small-12 medium-12 large-12">
        <div className="panel-label">
          Automation List
        </div>
        <div className="cell small-12 medium-12 large-12">
          {automations && automations.length ? (
            <div>
              <table className="vt-table automation-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Description</th>
                    {/* <th>Last Updated</th> */}
                    <th className="automation-lg">Automation Wallet Address</th>
                    <th className="automation-sm"></th>
                    <th className="automation-lg">
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableLoop}
                </tbody>
              </table>
            </div>
          ) : (
            <div>
              <table className="vt-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Priority</th>
                    {/* <th>Last Updated</th> */}
                    <th className="automation-lg">Wallet Address</th>
                    <th className="automation-sm"></th>
                    <th className="automation-lg"></th>
                  </tr>
                </thead>
              </table>
              <h3 className="no-data">No Automations</h3>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  automations: state.automation.automations,
  loading: state.automation.loading,
  errors: state.automation.errors,
  success: state.automation.success,
});

export default withRouter(connect(mapStateToProps)(ListAutomations));
